import { render, staticRenderFns } from "./InventionSave.vue?vue&type=template&id=47611a3f&"
import script from "./InventionSave.vue?vue&type=script&lang=js&"
export * from "./InventionSave.vue?vue&type=script&lang=js&"
import style0 from "./InventionSave.vue?vue&type=style&index=0&id=47611a3f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports